export default __webpack_public_path__ + "static/media/irisity-logo-animation.7f3fa58b.png";